import { useSelector } from 'react-redux';

import { IRemoteImageProps, IState } from 'typings';
import { logWarning } from 'utils/logging';

export const RemoteImage = ({
  alt = '',
  imageRef,
  mediaId,
  src: _src,
  ...props
}: IRemoteImageProps) => {
  const { sessionToken } = useSelector((state: IState) => ({
    sessionToken: state.auth.sessionToken,
  }));

  if (_src) {
    logWarning('Do not provide `src` to RemoteImage. It will be ignored.');
  }

  // If we don't have a sessionToken, we'll return null here to prevent a 401. Any resource requested by RemoteImage
  // should be one that requires authentication. If it doesn't require authentication, use <img />
  return sessionToken ? (
    <img
      alt={alt}
      ref={imageRef}
      src={`${process.env.REACT_APP_MEDIA_URI}/${mediaId}/?jwt=${sessionToken}`}
      {...props}
    />
  ) : null;
};
